import './styles.scoped.css'
import {Typography, IconButton, Tabs, Tab} from '@mui/material'
import {Menu as MenuIcon, Warning} from '@mui/icons-material'
import {useState, useEffect} from 'react'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {useMobile} from '../../hooks'
import {EvvVisits} from './components'
import {NotificationIcon} from '../../components'
import {clientApi, caregiverApi} from '../../services'
import {parseError} from '../../utils/helpers'
import dayjs from 'dayjs'
import {useSearchParams} from 'react-router-dom'

const TABS = ['all_status', 'pending_review', 'submitted', 'approved', 'rejected', 'cancelled', 'blocked']

export default () => {
    const {setMobileSidebar, setMessageBox, branchId} = useGlobalStates()
    // ?status=blocked opens that tab directly, so a count elsewhere in the app
    // (the dashboard's HHAX Sync card) can link to the visits it is counting
    // instead of dropping the user on All Statuses to find them again.
    const [searchParams] = useSearchParams()
    const requestedTab = TABS.indexOf(searchParams.get('status'))
    const [tab, setTab] = useState(requestedTab > 0 ? requestedTab : 0)
    const {mobile} = useMobile()
    // Arriving from a status link means arriving from a count that is not
    // scoped to a day — the dashboard's HHAX Sync card counts outstanding
    // obligations, however old. Keeping the usual "today" filter would drop the
    // visitor on an empty tab holding the very rows they clicked to see.
    const [startDate, setStartDate] = useState(requestedTab > 0 ? null : dayjs())
    const [endDate, setEndDate] = useState(requestedTab > 0 ? null : dayjs())
    const [clients, setClients] = useState([])
    const [caregivers, setCaregivers] = useState([])
    const [services, setServices] = useState([])

    useEffect(() => {
        if (mobile) {
            setMobileSidebar(false)
        }
    }, [])

    useEffect(() => {
        if (branchId) {
            clientApi
                .getBranchClients(branchId, {limit: 100})
                .then(
                    ({
                        data: {
                            data: {data},
                        },
                    }) => {
                        setClients(data?.map(item => ({...item, name: item?.first_name + ' ' + item?.last_name})))
                    },
                )
                .catch(error => {
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })

            caregiverApi
                .getBranchCaregivers(branchId, {limit: 100})
                .then(({data: {caregivers}}) => {
                    setCaregivers(caregivers?.map(item => ({...item, name: item?.first_name + ' ' + item?.last_name})))
                })
                .catch(error => {
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })

            clientApi
                .getBranchServices({branch_id: branchId})
                .then(({data: {data}}) => {
                    setServices(data?.map(item => ({...item, id: item?.service_id, name: item?.service_name})))
                })
                .catch(error => {
                    const {title, description} = parseError(error)
                    if (description) {
                        setMessageBox({status: 'error', title, description})
                    }
                })
        }
    }, [branchId])

    return (
        <>
            {mobile ? (
                <>
                    <div className="header">
                        <div className="title">
                            <IconButton onClick={() => setMobileSidebar(true)}>
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" color="text.primary">
                                EVV Management
                            </Typography>
                        </div>
                        <NotificationIcon />
                    </div>
                    <br />
                    <br />
                    <br />
                </>
            ) : (
                <>
                    <div className="header">
                        <Typography variant="h5" color="text.primary">
                            EVV Management
                        </Typography>
                    </div>
                    <br />
                    <br />
                </>
            )}
            <Tabs
                value={tab}
                onChange={(e, newValue) => setTab(newValue)}
                allowScrollButtonsMobile
                variant={'scrollable'}
                style={{width: mobile ? 420 : '100%'}}
            >
                <Tab label="All Statuses" />
                <Tab
                    label={
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6}}>
                            <Warning fontSize="small" color="warning" />
                            <span>Pending Review</span>
                        </div>
                    }
                />
                <Tab label="Submitted" />
                <Tab label="Approved" />
                <Tab label="Rejected" />
                <Tab label="Cancelled" />
                <Tab label="Blocked" />
            </Tabs>
            <br />
            <EvvVisits
                status={TABS[tab]}
                clients={clients}
                caregivers={caregivers}
                services={services}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
            />
        </>
    )
}
